var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "map_ic",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7151147,2.00490108 C9.37870257,2.0885913 7.19583231,3.18712545 5.74024107,5.01176911 C4.28464984,6.83641277 3.70192744,9.2046631 4.14523438,11.4940584 L4.14523438,11.4940584 C4.14523438,11.4940584 4.15763917,11.5800718 4.1983978,11.7444397 C4.32202726,12.2894278 4.50258778,12.8199924 4.73712046,13.3274388 C5.5387067,15.2220889 7.39529148,18.3939784 11.5544431,21.8409927 C11.8115459,22.0530024 12.1833973,22.0530024 12.4405001,21.8409927 C16.6037866,18.3957458 18.4585993,15.2256237 19.2643205,13.3227257 C19.5012712,12.8162446 19.6819212,12.2854169 19.8030431,11.7397267 C19.8402575,11.5800718 19.8562065,11.4893454 19.8562065,11.4893454 L19.8562065,11.4893454 C20.3158459,9.10290566 19.6606108,6.63760011 18.0760585,4.79158256 C16.4915061,2.94556501 14.1501766,1.9198462 11.7151147,2.00490108 L11.7151147,2.00490108 Z M11.998653,13.9466171 C9.85274171,13.9466171 8.11310643,12.2116997 8.11299771,10.0714998 C8.11288898,7.93129982 9.85234798,6.19620667 11.9982592,6.19598978 C14.1441705,6.19577288 15.8839821,7.93051436 15.8843084,10.0707143 C15.884465,11.0985593 15.475135,12.0843513 14.7463993,12.8111474 C14.0176636,13.5379436 13.0292409,13.9461842 11.998653,13.9460279 L11.998653,13.9466171 Z",
    id: "Path_5676",
    fill: "#081420",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIc);
export default __webpack_public_path__ + "static/media/map_ic.5839d6da.svg";
export { ForwardRef as ReactComponent };